/* Soleil Lune — product photo carousel: arrows, swipe, dots, infinite loop */
(function () {
  var root = document.querySelector('[data-sl-product]');
  var media = root && root.querySelector('.sl-pdp__media');
  var main = root && root.querySelector('[data-sl-main]');
  if (!media || !main) return;
  var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-sl-thumb]'));
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var css = document.createElement('style');
  css.textContent =
    '.sl-pdp__media{touch-action:pan-y;user-select:none;-webkit-user-select:none}' +
    '.sl-arrow{position:absolute;top:50%;z-index:3;transform:translateY(-50%);width:48px;height:64px;display:flex;align-items:center;justify-content:center;padding:0;border:0;background:none;color:#fff;cursor:pointer;filter:drop-shadow(0 1px 4px rgba(21,33,59,.5));transition:color .2s ease}' +
    '.sl-arrow:hover,.sl-arrow:focus-visible{color:var(--sl-red,#C1272D)}' +
    '.sl-arrow--prev{left:6px}.sl-arrow--next{right:6px}.sl-arrow[hidden],.sl-pips[hidden]{display:none}' +
    '.sl-pips{position:absolute;left:0;right:0;bottom:18px;z-index:3;display:flex;justify-content:center;flex-wrap:wrap;gap:8px;padding:0 60px}' +
    '.sl-pip{width:9px;height:9px;padding:0;border-radius:50%;border:1.5px solid #fff;background:transparent;cursor:pointer;transition:background .2s ease,transform .2s ease}' +
    '.sl-pip[aria-current="true"]{background:#fff;transform:scale(1.15)}' +
    '.sl-pip:hover{border-color:var(--sl-red,#C1272D);background:var(--sl-red,#C1272D)}' +
    '@media (max-width:749px){.sl-thumbs{display:none}}';
  document.head.appendChild(css);

  function arrow(cls, label, d) {
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'sl-arrow ' + cls; b.setAttribute('aria-label', label);
    b.innerHTML = '<svg width="28" height="28" viewBox="0 0 28 28" fill="none" stroke="currentColor" stroke-width="2.4" aria-hidden="true"><path d="' + d + '"/></svg>';
    media.appendChild(b); return b;
  }
  var prev = arrow('sl-arrow--prev', 'Previous photo', 'M17 5l-9 9 9 9');
  var next = arrow('sl-arrow--next', 'Next photo', 'M11 5l9 9-9 9');
  var pips = document.createElement('div');
  pips.className = 'sl-pips'; pips.setAttribute('role', 'group'); pips.setAttribute('aria-label', 'Photo position');
  media.appendChild(pips);

  function visible() { return thumbs.filter(function (t) { return !t.hidden; }); }
  function cur(list) { for (var i = 0; i < list.length; i++) if (list[i].getAttribute('aria-pressed') === 'true') return i; return 0; }

  function render() {
    var list = visible(), c = cur(list), many = list.length > 1;
    prev.hidden = next.hidden = pips.hidden = !many;
    pips.innerHTML = '';
    list.forEach(function (t, i) {
      var d = document.createElement('button');
      d.type = 'button'; d.className = 'sl-pip';
      d.setAttribute('aria-label', 'Photo ' + (i + 1) + ' of ' + list.length);
      if (i === c) d.setAttribute('aria-current', 'true');
      d.addEventListener('click', function () { go(i - cur(visible())); });
      pips.appendChild(d);
    });
  }

  function go(step) {
    var list = visible(), n = list.length;
    if (n < 2 || !step) return;
    var i = ((cur(list) + step) % n + n) % n; // wraps around: last -> first, first -> last
    list[i].click();
    if (!reduce && main.animate) {
      var dir = step > 0 ? 1 : -1;
      main.animate([{ opacity: 0, translate: (dir * 48) + 'px 0' }, { opacity: 1, translate: '0 0' }], { duration: 320, easing: 'cubic-bezier(.2,.8,.2,1)' });
    }
  }

  prev.addEventListener('click', function () { go(-1); });
  next.addEventListener('click', function () { go(1); });

  var sx = null, sy = 0;
  media.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
  media.addEventListener('touchend', function (e) {
    if (sx == null) return;
    var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy; sx = null;
    if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) go(dx < 0 ? 1 : -1);
  }, { passive: true });
  var mx = null;
  media.addEventListener('mousedown', function (e) { if (e.target.closest('button')) return; mx = e.clientX; e.preventDefault(); });
  window.addEventListener('mouseup', function (e) { if (mx == null) return; var dx = e.clientX - mx; mx = null; if (Math.abs(dx) > 50) go(dx < 0 ? 1 : -1); });
  document.addEventListener('keydown', function (e) {
    if (e.target.closest && e.target.closest('input,select,textarea')) return;
    if (e.key === 'ArrowRight') go(1); else if (e.key === 'ArrowLeft') go(-1);
  });

  // keep dots in sync when a thumb is clicked or the color changes
  if ('MutationObserver' in window) {
    var mo = new MutationObserver(render);
    thumbs.forEach(function (t) { mo.observe(t, { attributes: true, attributeFilter: ['aria-pressed', 'hidden'] }); });
  }
  render();
})();

/* Remember what this visitor looks at (stored only in their own browser) so suggestions can be tailored */
(function () {
  var m = location.pathname.match(/\/products\/([^\/?#]+)/);
  if (!m) return;
  var handle = m[1];
  var label = document.querySelector('[data-sl-colorlabel]');
  function save() {
    try {
      var list = JSON.parse(localStorage.getItem('sl_viewed') || '[]').filter(function (v) { return v.h !== handle; });
      list.unshift({ h: handle, c: label ? label.textContent.trim() : '', t: Date.now() });
      localStorage.setItem('sl_viewed', JSON.stringify(list.slice(0, 12)));
    } catch (e) {}
  }
  save();
  if (label && 'MutationObserver' in window) new MutationObserver(save).observe(label, { childList: true, characterData: true, subtree: true });
})();
